<template>
	<div class="Sayt" :style="$attrs.style" :class="$attrs.class" >
		<div v-if="errored" class="selected">
            <div class="error">Errored</div>
        </div>
		<div v-else-if="selected_id!==null" class="selected" >
			<div v-if="!items_loaded" class="loading">Loading</div>
			<div v-else-if="selected_item===null" class="error" >Item not found</div>
			<div v-else >
				{{ selected_item.label }}
			</div>
			<button type="button" @click="selected_id=null" >&times; clear</button>
		</div>
		<template v-else >
			<input type="text" v-model="sayt_text" ref="in_item" @focus="saytFocus" @blur="saytBlur" @keydown="saytKeydown" :required="required" :placeholder="no_options?'No options available':placeholder" >
			<div v-if="sayt_open" class="sayt_options" >
				<div v-if="!items_loaded" class="loading">Loading</div>
				<div v-else-if="!filtered_items.length && !can_create" class="notfound" >None found</div>
				<template v-else >
					<div v-for="(item,k) in filtered_items.slice(0,10)" :key="item.id" :class="{focused:k==sayt_position,selectable:1}" @click="selectPosition(k)" >
						{{ item.label }}
					</div>
					<div v-if="can_create && filtered_items.length<=10" :class="{focused:sayt_position==filtered_items.length,selectable:1,create:1}" @click="selectPosition(filtered_items.length)" >
						+ Create
					</div>
				</template>
				<div v-if="filtered_items.length > 10" style="font-size:0.8em;color:#AAA" >
					+ {{ filtered_items.length - 10 }} more items
				</div>
			</div>
		</template>
	</div>
</template>
<script>

	import {ref} from "vue";

	export default {


		props : [
			// Provide one of these two. 'data' takes precedent
			'data', 
			'data_url', 

			// Form
			'required', 	// boolean 
			'render', 		// x=>{value:x.id,label:x.name} 
			'modelValue', 	// v-model - selected value

			'placeholder',  // (optional)
			'createAction', // (optional) function - ability to create a new item 
		],
		
		setup(props) {
			return {

				// States
				errored      	: ref(false),
				data_loaded 	: ref(false),
				loaded_data 	: ref([]),
				sayt_text 		: ref(''),
				sayt_focused 	: ref(false),
				sayt_open 		: ref(false),
				sayt_position 	: ref(null),
				selected_id 	: ref(props.modelValue || null),
			};
		},

		
		mounted(){
		},

		computed:{
			no_options(){
				return this.items_loaded && !this.items.length && !this.can_create;
			},
			mode(){
				return this.data !== undefined ? 'DATA' : 'URL' ;
			},
			data_to_use(){
				return this.mode == 'DATA' ? this.data : this.loaded_data;
			},
			render_function(){
				return this.render || this.defaultRender;
			},
			items(){
				return (this.data_to_use||[]).map(this.render_function);
			},
			can_create(){
				return typeof this.createAction === "function";
			},
			items_loaded(){
				return this.mode == 'DATA' ? this.data!==null : this.data_loaded;
			},
			filtered_items(){
				if(!this.items) return [];

				return this.items.map(item=>{

					var score = this.saytSearchScore( this.sayt_text , item.label);

					// if( (item.id+'').toLowerCase().includes(this.sayt_text.trim().toLowerCase()) ){
					// 	score = Math.max(score,this.sayt_text.length + 3);
					// }

					return {
						...item,
						search_score : score,
					}
				}).filter(item=>{
					return item.search_score && item.search_score > 0;
				}).sort((a,b)=>{
					if(a.search_score > b.search_score) return -1;
					if(a.search_score == b.search_score) return 0;
					return 1;
				}) || [];
			},
			selected_item(){
				var self = this;
				
				return (this.selected_id!==null && this.items !== null) ? this.items.find(item=>{
					return item.id==self.selected_id;
				}) || null : null;
			},
		},

		watch:{
			selected_id(){
                if(this.selected_id!=this.modelValue){
                    this.$emit('update:modelValue',this.selected_id);
                    this.$emit('selection',this.selected_item);
                }
			},
            modelValue(v){
                this.selected_id = v;
            },
		},

		mounted(){
			if(this.mode=="URL"&&this.data_url) this.getData();
		},


		methods: {
			
			defaultRender(item){
				return {
					id : item.id,
					label : item.name || item.id,
				};
			},
			
			focus(){
				var self = this;
				if(this.selected_id===null){
					self.$refs.in_item.focus();
				}
			},
			
			saytSearchScore(needle,haystack){
				const search_string = needle.toLowerCase().trim();
				const split_search_string = search_string.split(' ');
				const body = (""+haystack).toLowerCase(); // make sure haystack is a string (in case it's an int)

				// If spaces in search, return AND
				if(split_search_string.length > 1){
					return split_search_string.reduce( (a,segment) => {
						if(a===false) return false;
						const score = this.saytSearchScore(segment,body);
						if(score===false) return false;
						return a + score;

					},0);
				}

				if(!search_string) return true;

				const search_characters = search_string.split('');

				const hit_distribution = search_characters.reduce( ( prev_hits , character )=>{
					if(prev_hits === false) return false;
					const prev_position = prev_hits.length ? prev_hits[prev_hits.length-1] : -1;
					const next_hit = body.indexOf(character,prev_position+1);
					if(next_hit == -1) return false;
					prev_hits.push(next_hit);
					return prev_hits;
				},[]);

				if(hit_distribution === false ) return false;

				let prev_pos = -1;
				let current_chain_length = 1;
				let longest_chain_length = 1;
				for (let i = 0; i < hit_distribution.length; i++) {
					const hit_pos = hit_distribution[i];
					if(hit_pos-1 == prev_pos){
						current_chain_length++;
						longest_chain_length = Math.max(longest_chain_length,current_chain_length);
					} else {
						current_chain_length = 1;
					}
					prev_pos = hit_pos;
				}

				return longest_chain_length;

			},
			
			saytFocus(e){
				this.sayt_focused = true;
				this.saytFocuschange();
			},

			saytBlur(e){
				this.sayt_focused = false;
				this.saytFocuschange();
			},
			
			saytKeydown(e){

				var n_options = this.filtered_items.length;
				if(this.createAction) n_options++;
				var pos = this.sayt_position;

				switch(e.code){
					case 'ArrowDown':
						this.sayt_position = (pos+1)%n_options;
						e.preventDefault();
						e.stopPropagation();
						break;
					case 'ArrowUp':
						this.sayt_position = ((pos-1)%n_options+n_options)%n_options;
						e.preventDefault();
						e.stopPropagation();
						break;
					case 'Enter':
						this.selectPosition(pos);
						e.preventDefault();
						e.stopPropagation();
						break;
				}

			},

			selectPosition(x){
				if(this.createAction && x == this.filtered_items.length ){
					this.createAction(this.sayt_text,this);
				} 
				if(x<this.filtered_items.length){
					var item = this.filtered_items[x];
					this.selected_id = item.id;
				}
				this.saytClose();
			},

			saytFocuschange(){
				var self = this;
				if(this.sayt_focused){				
					this.saytOpen();
				} else {
					setTimeout(function(){
						if(!this.sayt_focused) self.saytClose();
					},200);
				}
			},

			saytClose(){
				this.sayt_text = '';
				this.sayt_open = false;
			},
		
			saytOpen(){
				this.sayt_position = 0;
				this.sayt_open = true;
			},

			
			// getData(){
			// 	var self = this;
			// 	self.data_loaded = false;

			// 	return axios.get().then(({data})=>{
			// 		self.loaded_data = data.data;
			// 	}).catch((e)=>{
			// 		self.errored = true;
			// 		console.error(e)
			// 	}).finally(()=>{
			// 		self.data_loaded = true;
			// 	})
				
			// },

            async getData(){
				
				this.data_loaded = false;

                this.loaded_data = [];
                let page = 0;
                let last_page = null;

                 try {
                    do{
                        page = page+1;
                        const response = await axios.get(this.data_url,{params:{page}});
                        this.loaded_data = [...this.loaded_data,...response.data.data];
                        last_page = ((response.data||{}).meta||{}).last_page||1;
                    } while(page<last_page);
                    this.data_loaded = true; 
				    this.$emit('loaded',this.loaded_data);
                } catch (e) {
                    this.errored = true;
					console.error(e)
                }

			},

		}
	}
</script>